import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ViewStreamOutlinedIcon from '@mui/icons-material/ViewStreamOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined';

// Sidebar sections. `role` is the permission code checked against
// localStorage 'role'; items without one are always visible.
const menuGroups = [
    {
        label: 'Үндсэн',
        items: [
            { path: 'Dashboard', label: 'Хяналтын самбар', icon: <AssessmentOutlinedIcon /> },
        ],
    },
    {
        label: 'Бүртгэл',
        items: [
            { path: 'Companies', label: 'Компани', role: '101', icon: <StoreOutlinedIcon /> },
            { path: 'Customers', label: 'Харилцагч', role: '102', icon: <PeopleAltOutlinedIcon /> },
            { path: 'Brands', label: 'Брэнд', role: '103', icon: <LocalOfferOutlinedIcon /> },
            { path: 'Bonus', label: 'Урамшуулал', role: '104', icon: <CardGiftcardOutlinedIcon /> },
            { path: 'DiscountProduct', label: 'Хямдралтай бүтээгдэхүүн', role: '104', icon: <DiscountOutlinedIcon /> },
            { path: 'Products', label: 'Бүтээгдэхүүн', role: '105', icon: <Inventory2OutlinedIcon /> },
        ],
    },
    {
        label: 'Гүйлгээ',
        items: [
            { path: 'Orders', label: 'Захиалга', role: '106', icon: <ViewStreamOutlinedIcon /> },
            { path: 'Transactions', label: 'Гүйлгээ', role: '107', icon: <ReceiptLongOutlinedIcon /> },
        ],
    },
    {
        label: 'Тайлан',
        items: [
            { path: 'OrderDailyRep', label: 'Өдрийн нэгтгэл тайлан', role: '108', icon: <AssignmentOutlinedIcon /> },
            { path: 'OrderGrpRep', label: 'Захиалга нэгтгэл тайлан', role: '109', icon: <SummarizeOutlinedIcon /> },
            { path: 'OrderRep', label: 'Захиалга тайлан', role: '110', icon: <TextSnippetOutlinedIcon /> },
            { path: 'OrderRepAll', label: 'Захиалга тайлан бүгд', role: '111', icon: <ListAltOutlinedIcon /> },
        ],
    },
    {
        label: 'Зээл',
        items: [
            { path: 'LoanHistory', label: 'Зээлийн түүх', role: '112', icon: <CreditCardOutlinedIcon /> },
            { path: 'LoanPayments', label: 'Зээлийн төлөлт', role: '113', icon: <CreditScoreOutlinedIcon /> },
        ],
    },
];

export const visibleMenuGroups = () => {
    const role = localStorage.getItem('role') || '';
    return menuGroups
        .map((g) => ({ ...g, items: g.items.filter((i) => !i.role || role.includes(i.role)) }))
        .filter((g) => g.items.length > 0);
};

// Pages reached from inside other pages rather than from the menu.
const extraTitles = {
    orderadd: 'Захиалга авах',
    ordermod: 'Захиалгын дэлгэрэнгүй',
};

// Title for the header, matched case-insensitively like react-router does.
export const pageTitle = (pathname) => {
    const seg = pathname.replace(/^\/+/, '').split('/')[0].toLowerCase();
    if (seg === '') return 'Хяналтын самбар';
    if (extraTitles[seg]) return extraTitles[seg];
    for (const g of menuGroups) {
        const hit = g.items.find((i) => i.path.toLowerCase() === seg);
        if (hit) return hit.label;
    }
    return '';
};

export default menuGroups;
